import React from 'react';
import './style.css';

const TransparentOverlay = ({ show }: { show: boolean }) => {
  if (!show) return null;
  return <div className="transparent-overlay-container" />;
};

export default TransparentOverlay;
